import React, { Component } from 'react';
import { Badge } from 'react-bootstrap';

export default class RuleTypeCellRenderer extends Component {
    render() {
        const type = this.props.value;
        let bg = 'secondary';
        let text = type || '';

        switch (type) {
            case 'result_based':
                bg = 'primary';
                text = 'Result Based';
                break;
            case 'pattern_based':
                bg = 'success';
                text = 'Pattern Based';
                break;
            case 'combination':
                bg = 'warning';
                text = 'Combination';
                break;
            case 'medication_based':
                bg = 'danger';
                text = 'Medication Based';
                break;
            default:
                // If type exists but doesn't match any case, show it with proper formatting
                if (type) {
                    text = type.split('_').map(word => 
                        word.charAt(0).toUpperCase() + word.slice(1)
                    ).join(' ');
                }
                break;
        }

        if (!text) {
            return null;
        }

        return (
            <Badge bg={bg}>{text}</Badge>
        );
    }
}